import { type ReactNode } from 'react';
import { Flex } from 'antd';

import { EnumVerifyPayeeMatch } from '../../api/vop/vop';
import { trb } from 'src/Utilities';
import { AlertNotification } from 'src/shared';

interface IProps {
  status: EnumVerifyPayeeMatch;
  matchedName?: string | null;
  field?: ReactNode; // Checkbox for approval
  alertTitle?: string;
  alertDescription?: string;
}

const statusConfig: Record<EnumVerifyPayeeMatch, { type: 'success' | 'error' | 'warning' | 'info'; approveRequired: boolean }> = {
  [EnumVerifyPayeeMatch.NOAP]: { type: 'error', approveRequired: false },
  [EnumVerifyPayeeMatch.NOAP_OPT]: { type: 'error', approveRequired: false },
  [EnumVerifyPayeeMatch.MTCH]: { type: 'success', approveRequired: false },
  [EnumVerifyPayeeMatch.CMTC]: { type: 'warning', approveRequired: false },
  [EnumVerifyPayeeMatch.NMTC]: { type: 'error', approveRequired: false },
};

export const PayeeVerificationMessage = ({ status, matchedName, field, alertTitle = 'PayeeVerificationTitle', alertDescription = 'PayeeVerificationDescription' }: IProps) => {
  const { type, approveRequired } = statusConfig[status] ?? {};

  const getTitle = () => {
    if (statusConfig[status]) {
      return trb(`${alertTitle}.${status}`);
    }

    return null;
  };

  const getDescription = () => {
    if (status === EnumVerifyPayeeMatch.CMTC && matchedName) {
      return trb(`${alertDescription}.${status}`, { value: matchedName });
    }

    if (statusConfig[status]) {
      return trb(`${alertDescription}.${status}`);
    }

    return null;
  };

  const title = getTitle();
  const description = getDescription();

  if (!status || !statusConfig[status] || !type) {
    return null;
  }

  return (
    <AlertNotification
      type={type}
      message={title ? <span dangerouslySetInnerHTML={{ __html: title }} /> : undefined}
      description={
        <Flex
          vertical
          gap={12}
        >
          {description && <span dangerouslySetInnerHTML={{ __html: description }} />}
          {approveRequired && field}
        </Flex>
      }
    />
  );
};
